    export const normalizeHexColor = (hex) => {
      if (!hex || typeof hex !== "string") {
        return null;
      }
      const sanitizedHex = hex.trim();

      if (sanitizedHex.startsWith("#")) {
        if (
          /^#[0-9A-Fa-f]{6}$/.test(sanitizedHex) ||
          /^#[0-9A-Fa-f]{3}$/.test(sanitizedHex)
        ) {
          return sanitizedHex;
        }
      } else if (
        /^[0-9A-Fa-f]{6}$/.test(sanitizedHex) ||
        /^[0-9A-Fa-f]{3}$/.test(sanitizedHex)
      ) {
        return `#${sanitizedHex}`;
      } else if (sanitizedHex.includes(":")) {
        const parts = sanitizedHex.split(":");
        if (parts.length === 2) {
          const potentialHex = parts[1].trim();
          if (/^[0-9A-Fa-f]{3,6}$/.test(potentialHex)) {
            return `#${potentialHex}`;
          }
        }
      }

      console.warn(`Invalid or unhandled hex color format: ${hex}`);
      return null;
    };
